import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from '../../buttons/defaultCommandPanelButton';

export function SettingsButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faGears} />}
      color="secondary"
    />
  );
}

SettingsButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

SettingsButton.defaultProps = {
  onClick: () => null,
  content: 'Показати налаштування',
  disabled: false,
};

export default SettingsButton;
